import { environment } from '@env/environment';

export class ApiConfig {
  public static get url(): string {
    return environment.api.host;
  }

  public static get prefix(): string {
    return environment.api.prefix;
  }

  public static get urlMensagem(): string {
    return environment.mensagem.url;
  }

  public static get prefixMensagem(): string {
    return environment.mensagem.prefix;
  }
}
